import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-150-fill",
  "use": "icon-150-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-150-fill\" viewBox=\"0 0 16 16\" id=\"icon-150-fill\">\n  <path d=\"M6.264 2a.486.486 0 0 0-.182.036 6.204 6.204 0 0 0-3.878 6.137 6.276 6.276 0 0 0 5.82 5.817c.12.007.24.01.36.01a6.193 6.193 0 0 0 5.775-3.968.5.5 0 0 0-.48-.671.537.537 0 0 0-.14.019 5.366 5.366 0 0 1-1.408.189 5.595 5.595 0 0 1-1.851-.322 5.56 5.56 0 0 1-3.542-6.612A.505.505 0 0 0 6.264 2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol